<template>
  <div class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
    <div
      class="d-flex flex-column flex-md-row align-items-center justify-content-between"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <!-- <div class="text-dark order-2 order-md-1">
        <span class="text-muted font-weight-bold mr-2">2026©</span>
        <a
          target="_blank"
          class="text-dark-75 text-hover-primary"
          >Desenvolvido By Nuts Tecnologia</a
        >
      </div> -->
      <div class="nav nav-dark order-1 order-md-2">
        <button
          v-if="showPdvShortcuts"
          type="button"
          class="nav-link pr-3 pl-0 footer-shortcuts-link"
          v-b-modal.modal-atalhos-pdv
        >
          Atalhos
        </button>
        <a href="/#/termos" target="_blank" class="nav-link pr-3 pl-0"
          >Termos</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),

    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },

    showPdvShortcuts() {
      return ["vendasNovo", "vendasEditar"].includes(this.$route.name);
    },
  },
};
</script>

<style scoped>
.footer-shortcuts-link {
  border: 0;
  background: transparent;
  color: #7e8299;
  font-size: 0.92rem;
  cursor: pointer;
}

.footer-shortcuts-link:hover,
.footer-shortcuts-link:focus {
  color: #f64e60;
  text-decoration: none;
  outline: 0;
}
</style>
